import React, { useEffect, useState } from 'react';
import {
    Card,
    CardActionArea,
    CardContent,
    Box,
    Grid,
    Button,
    Alert
} from '@mui/material';
import TeamPerformance from '../TeamPerformance/TeamPerformance';
import { useNavigate } from 'react-router';
import { axiosFetch } from '../../../../utils/AxiosFetch';
import moment from 'moment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import EventIcon from '@mui/icons-material/Event';
import { SnackbarActions } from '../../../../redux/actions/snackbar.actions';
import { useDispatch } from 'react-redux';
import { color } from '@mui/system';
const MyPerformace = () => {

    const isShowAll = true;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formList, setFormList] = useState([]);
    var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";



    const handleReviewForm = (id) => {
        navigate(`/form/${id}`);
    };



    const loadPreviousSessionData = () => {
        axiosFetch({
            method: "get",
            url: `/Performance/list/${isShowAll}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setFormList(res.data);
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err => {
                console.error(err);
            })
    }

    useEffect(() => {

        loadPreviousSessionData();

    }, [])

    return (
        <div>
            <Grid container spacing={2}>
                
                <Grid item xs={12}>
                <div className="annual-apprasial-forms-bg">
                    {/* <Box> */}
                    <h1 className='main-heading'>My Performance</h1>
                    {/* <p style={{ marginTop:"0px", color:"#ff0000", fontStyle:"italic"}} >The scores for the completed reviews will be displayed shortly.</p> */}
                    <Grid container spacing={2}>
                        {formList.length !== 0 ? formList.map((data) => (
                            <Grid item xs={3}>
                                <Card onClick={() => handleReviewForm(data.id)} variant="outlined" className='teamperformance-box myperformace' sx={{ borderRadius: "15px !important" }}>
                                    <CardActionArea>
                                        <CardContent className='pmp-card'>
                                            <span className='pmp-datefield'>
                                                <CalendarMonthIcon className='date-field' /> {data.period !== "" ? data.period : "-"}
                                            </span>
                                            {/* BELOW CODE IS COMMENTED BY SUNDARESH FOR TEMPORARY LIVE FIX 23/12/2022 */}
                                            {!data.isCompleted ? "" : <span className='pmp-score'>Score : {data.overAllScore !== null ? data.overAllScore + "%" : "-"}</span>}
                                            
                                            <div className='pmp-review'>
                                                {!data.isCompleted ? "" : <span><EventIcon className="date-field" /> Review Date : {data.reviewDate !== null ? moment(data.reviewDate).format('MMM-DD-YYYY') : "-"}</span>}
                                                {!data.isCompleted ? "" : <span><PersonIcon className="date-field" /> Review By : {data.reviewer !== null ? data.reviewer : "-"}</span>}
                                            </div>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>)) : <Grid item xs={12}><Alert severity="error">No Review History</Alert></Grid>}
                    </Grid>
                    </div>
                    {/* <Button variant='contained' sx={{marginTop: "13px"}} onClick={generateNewFormId} className='theme-btn'>Open Current Review Form</Button> */}
                    {/* <Card variant="outlined">
                            <CardActionArea onClick={handleReviewForm}>
                                <CardContent>
                                    <center>
                                        <h2>Jun-2021</h2>
                                    </center>
                                </CardContent>
                            </CardActionArea>
                        </Card> */}
                    {/* <Card variant="outlined">
                            <CardActionArea onClick={generateNewFormId}>
                                <CardContent>
                                    <center>
                                        <h2>Open Current Review Form</h2>
                                    </center>
                                </CardContent>
                            </CardActionArea>
                        </Card> */}

                    {/* </Box> */}
                </Grid>
                {isUserLogged.isManager === true?
                <Grid item xs={12}>
                    <TeamPerformance />
                </Grid>:""}
            </Grid>

        </div>
    )
}

export default MyPerformace;